export const chats = {
  chatListChatIfoAttachmentsText: 'Pièce(s) jointe(s) envoyée(s)',
  chatListChatNoMessagesText: 'Aucun message pour l’instant',
  chatArchivedTitle: 'Chats archivés',
  chatsCreatePrivateCurtainTitle: 'Nouveau chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Rechercher',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Créer',
  chatCreateButtonTitle: 'Suivant',
  chatCreateNewGroupHeader: 'Nouveau groupe',
  chatGroupNameInputTitle: 'Nom du groupe',
  chatLogoTitle: 'Éditer',
  chatCreateGroupButtonTitle: 'Créer le groupe',
  chatRequiredFieldsAlert: 'Le nom du groupe doit être spécifié !',
  chatsCreateGroupChatLongTitleAlertText: 'Veuillez utiliser un titre plus court !',
  chatsCreateGroupChatLBigImageAlertText: 'Veuillez choisir une image plus petite !',
  chatsNewChatInputPlaceholder: 'Écrire un message',
  chatsNewChatAddedBigImageAlertText: 'Veuillez choisir une image plus petite !',
  chatOwnersArchiveOptionText: 'Archiver',
  chatOwnersEditGroupOptionText: 'Modifier',
  chatOwnersManageGroupOptionText: 'Gérer les membres',
  chatOwnersChangeGroupOptionText: 'Changer le propriétaire du groupe',
  chatOwnersLeaveGroupOptionText: 'Quitter',
  chatOwnersDeleteGroupOptionText: 'Supprimer le chat',
  chatpopupArchivedTitle: 'Archiver le chat',
  chatpopupArchivedDescription: 'Êtes-vous sûr(e) ?',
  chatArchiveGroupButtonTitleYes: 'Confirmer',
  chatArchiveGroupButtonTitleCancel: 'Annuler',
  chatEditGroupHeader: 'Modifier le chat',
  chatEditGroupEditLogoTitle: 'Éditer',
  chatEditGroupButtonTitle: 'Enregistrer',
  chatGroupEditAlertText: 'Enregistrement réussi !',
  chatManageGroupHeader: 'Gérer',
  chatManageGroupButtonTitle: 'Ajouter un membre',
  chatManageGroupSaveButtonTitle: 'Enregistrer',
  chatAddUsersGroupHeader: 'Ajouter des membres',
  chatAddUsersGroupButtonTitle: 'Confirmer',
  chatAddUsersGroupSearchInputPlaceholder: 'Rechercher',
  chatOwnershipTransferHeader: 'Transférer la propriété',
  chatOwnershipTransferSearchInputPlaceholder: 'Rechercher',
  chatOwnershipTransferButtonTitle: 'Confirmer',
  chatOwnerMarkText: '(vous)',
  chatOwnershipTransferAlertText: 'Propriété transférée !',
  chatOwnerLeaveGroupTitle: 'Quitter le groupe',
  chatOwnerLeaveGroupDescription:
    'Vous êtes propriétaire du chat, donc vous devez d’abord choisir un nouveau propriétaire avant de partir.',
  chatOwnerLeaveGroupButtonTitleYes: 'Choisir',
  chatOwnerLeaveGroupButtonTitleNo: 'Annuler',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archiver',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Membres du chat',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Quitter',
  chatsGroupChatMemberCurtainTitle: 'Membres du chat',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Rechercher',
  chatsGroupChatMemberCurtainOwnerMarkText: '(propriétaire)',
  chatsGroupChatLeavePopupTitle: 'Quitter',
  chatsGroupChatLeavePopupText: 'Êtes-vous sûr(e) ?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Annuler',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Confirmer',
  chatDeleteGroupTitle: 'Supprimer le chat',
  chatDeleteGroupDescription: 'Le chat et son historique seront supprimés pour tous les participants, continuer ?',
  chatDeleteGroupButtonTitleYes: 'Confirmer',
  chatDeleteGroupButtonTitleNo: 'Annuler',
  chatsPrivateChatCurtainArchOptionTitle: 'Archiver',
  chatsEditMessage: 'Modifier le message',
  chatsCopyMessage: 'Copier le message',
  chatsDeleteMessage: 'Supprimer le message',
  chatsSelectMessage: 'Sélectionner le message',
  chatMarkTextEdit: '(modifié)',
  chatCopyMessageAlertText: 'Message copié !',
  chatDeleteMessageTitle: 'Supprimer le message',
  chatDeleteMessageDescription: 'Supprimer ce message ?',
  chatDeleteMessageButtonTitleYes: 'Confirmer',
  chatDeleteMessageButtonTitleNo: 'Annuler',
  chatSelectButtonDelete: 'Annuler',
  chatSelectButtonNo: 'Supprimer',
  chatDeleteMessagesTitle: 'Supprimer les messages',
  chatDeleteMessagesDescription: 'Supprimer ces messages ?',
  chatDeleteMessagesButtonTitleYes: 'Confirmer',
  chatDeleteMessagesButtonTitleNo: 'Annuler',
  chatArchiveButtonRestore: 'Restaurer',
  chatArchiveButtonNo: 'Supprimer',
  chatNoUsersCurtainTitle: 'Oups !',
  chatsNoUsersCurtainText: 'Il semble qu’il n’y ait aucun autre utilisateur que vous. Invitez des amis pour commencer à discuter.',
  chatsNoUsersCurtainCancelButtonTitle: 'Annuler',
  chatsNoUsersCurtainCopyButtonTitle: 'Copier le lien de l’application',
  chatsAppLinkCopiedAlertText: 'Lien copié !',
  chatsTooFewUsers: 'Veuillez sélectionner au moins un utilisateur pour commencer à discuter !',
  chatsError: 'Quelque chose s’est mal passé !'
}
